import React, { useState, useEffect } from 'react';
import { klasaStatusu } from '../lib/paymentStatus';
import Button from './Button';
import PaymentsIcon from '../assets/images/nav-icons/payments.svg';
import CloseIcon from '../assets/images/close.svg';
import { firestore } from '../lib/firebaseConfig';
import { doc, updateDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import PaymentsTableHeader from './PaymentsTableHeader';
import ConfirmDialog from './ConfirmDialog';
import { useToast } from '../context/ToastContext';
import Pagination from './Pagination';
const TableCheckBox = ({ onChange }) => (
  <input
    className="flex items-center justify-center appearance-none w-4 h-4 border border-[#D7D7D7] rounded-[4px] checked:before:content-['✅'] checked:before:w-4 checked:before:h-4"
    type="checkbox"
    onChange={onChange}
  />
);

const TableCustomers = ({
  topContent,
  data,
  setData,
  bill,
  editable = false,
  hasActions = false,
  showTotalPrimary,
  showTotalSecondary,
  className,
  onModalOpen,
  onEditClient,
  headerTitle
}) => {
  const { showError } = useToast();
  const [tableData, setTableData] = useState(data);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortField, setSortField] = useState('');
  const [sortOrder, setSortOrder] = useState('asc');
  const [filteredData, setFilteredData] = useState(data);
  const [flatToUnsold, setFlatToUnsold] = useState(null);
  const [statusFilter, setStatusFilter] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);
useEffect(() => {
  setTableData(data);  // Update tableData whenever new data is passed from the parent
}, [data]);

  const navigate = useNavigate();

  const handleNavigate = (flatId, clientId, investmentId) => {
    console.log(flatId);
    navigate('/payments', {
      state: { flatId, clientId, investmentId },
    });
  };

  const handleMarkAsUnsoldClick = (flatId, investmentId, flatCode) => {
    setFlatToUnsold({ flatId, investmentId, flatCode });
  };

  const confirmMarkAsUnsold = async () => {
    if (!flatToUnsold) return;

    const { flatId, investmentId, flatCode } = flatToUnsold;

    try {
      const flatRef = doc(firestore, `investments/${investmentId}/flats/${flatId}`);
      await updateDoc(flatRef, {
        status: 'available'
      });

      // Remove from local state
      const updatedData = data.filter(row => row.flatId !== flatId);
      setData(updatedData);
      setFilteredData(updatedData);

      console.log(`Flat ${flatCode} marked as unsold.`);
    } catch (error) {
      console.error('Error marking flat as unsold:', error);
      showError('Nie udało się zmienić statusu lokalu.');
    }

    setFlatToUnsold(null);
  };

const sortableFields = ['code', 'size', 'an_amount'];

const columnHeaders = {
  code: 'Lokal',
  payment_status: 'Status',
  floor: 'Piętro',
  size: 'Powierzchnia',
  type: 'Typ mieszkania',
  an_amount: 'Cena sprzedaży brutto',
  paid_amount: 'Zapłacono',
  left_amount: 'Pozostało',
  paid_out_amount: 'Wypłacono',
  reservation_amount: 'Opłata rezerwacyjna',
  paid_date: 'Data zapłaty',
  paid_back_amount: 'Zwrócono',
  paid_back_date: 'Data zwrotu',
  paid_to_corp: 'Przekazano na rachunek deweloperski',
  date_paid_to_corp: 'Data przekazania',
  left_for_corp_amount: 'Pozostało',
  comment: 'Komentarz',
  mandatory_amount: 'Wymagane wpłaty',
  missing_amount: 'Pozostało do zapłaty',
};




const hiddenFields = ['clientIds', 'investmentId', 'flatId', 'type'];

  const basicTdClasses = 'py-[15px] px-[15px] text-left';

const calculateSummary = (data) => {
  const summary = {
    'Kwota z AN': 0,
    Zapłacono: 0,
    Pozostało: 0,
    Wypłacono: 0,
    'Opłata rezerwacyjna': 0,
    'Data zapłaty': '-',
  };

  data.forEach((row) => {
    summary['Kwota z AN'] += parseFloat(row.an_amount || 0);
    summary['Zapłacono'] += parseFloat(row.paid_amount || 0);
    summary['Pozostało'] += parseFloat(row.left_amount || 0);
    summary['Wypłacono'] += parseFloat(row.paid_out_amount || 0);
    summary['Opłata rezerwacyjna'] += parseFloat(row.reservation_amount || 0);
  });

  // Format as currency
  Object.keys(summary).forEach((key) => {
    if (key !== 'Data zapłaty') {
      summary[key] = `${summary[key].toLocaleString()} zł`;
    }
  });

  return summary;
};

const summary = calculateSummary(filteredData);

  useEffect(() => {
    let updatedData = [...data];

    // Filter by status
    if (statusFilter) {
      updatedData = updatedData.filter((row) => row.payment_status === statusFilter);
    }

    // Full-text search on code and client name
    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      updatedData = updatedData.filter((row) => {
        // Search in code
        if (row.code && String(row.code).toLowerCase().includes(searchLower)) {
          return true;
        }
        // Search in client names (Nabywca field - can be array or string)
        if (row['Nabywca']) {
          if (Array.isArray(row['Nabywca'])) {
            return row['Nabywca'].some(name =>
              String(name).toLowerCase().includes(searchLower)
            );
          }
          return String(row['Nabywca']).toLowerCase().includes(searchLower);
        }
        return false;
      });
    }

    // Sort data if a sort field is selected
    if (sortField) {
      updatedData.sort((a, b) => {
        let aValue = a[sortField];
        let bValue = b[sortField];

        // Check if the field is 'code', and if so, sort numerically
        if (sortField === 'code') {
          const aNumeric = parseInt(String(aValue).replace(/[^\d]/g, '')) || 0;
          const bNumeric = parseInt(String(bValue).replace(/[^\d]/g, '')) || 0;
          return sortOrder === 'asc' ? aNumeric - bNumeric : bNumeric - aNumeric;
        }

        if (sortField === 'size' || sortField === 'an_amount') {
          aValue = parseFloat(aValue) || 0;
          bValue = parseFloat(bValue) || 0;
        }

        if (sortOrder === 'asc') {
          return aValue > bValue ? 1 : -1;
        } else {
          return aValue < bValue ? 1 : -1;
        }
      });
    }

    setFilteredData(updatedData);
    setCurrentPage(1); // Reset to first page when filters change
  }, [searchTerm, sortField, sortOrder, statusFilter, data]);

  // Paginate the filtered data
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = filteredData.slice(startIndex, startIndex + itemsPerPage);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleStatusFilter = (status) => {
    setStatusFilter(status);
  };

  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
  };

  const handleSortChange = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortOrder('asc');
    }
  };

  return (
    <div
      className={`${className} bg-white rounded-[6px] border border-[var(--bright-gray)] text-[var(--electric-blue)] overflow-x-auto w-[calc(100vw-380px)] max-1024:w-[calc(100vw-255px)] max-768:w-[calc(100vw-55px)]`}
    >
      <div className="sticky left-0 py-[20px] px-[20px] border-b border-[var(--bright-gray)]">
        <PaymentsTableHeader
          onModalOpen={onEditClient}
          headerTitle={headerTitle}
          handleSearch={handleSearch}
          handleSortChange={handleSortChange}
          handleStatusFilter={handleStatusFilter}
          statusFilter={statusFilter}
        />
      </div>
      <table className="w-full whitespace-nowrap relative">
        <thead>
          <tr className="bg-[var(--lotion)] border-b border-[var(--bright-gray)]">
            {editable && (
              <th className={`${basicTdClasses} w-[54px]`}>
                <TableCheckBox onChange={() => {}} />
              </th>
            )}
            <th className={`${basicTdClasses} font-medium`}>Lp.</th> {/* Lp. column */}
      {Object.keys(tableData[0] || {})
        .filter((key) => !hiddenFields.includes(key))  // Filter out hidden fields
        .map((key) => (
          <th key={key} className={`${basicTdClasses} font-medium cursor-pointer` } onClick={() => sortableFields.includes(key) && handleSortChange(key)}>
            {columnHeaders[key] || key}
                  {sortableFields.includes(key) && sortField === key && (
        <span>{sortOrder === 'asc' ? ' ▲' : ' ▼'}</span>
      )}
          </th>
        ))}
            {hasActions && <th className={`${basicTdClasses} w-[54px]`}></th>}
            {hasActions && <th className={`${basicTdClasses} w-[54px]`}></th>}
          </tr>
        </thead>
        <tbody>
          {paginatedData.map((row, rowIndex) => (
            <tr key={rowIndex} className="border-b border-[var(--bright-gray)]">
              {editable && (
                <td className="text-left py-[22px] px-[15px] w-[54px]">
                  <TableCheckBox onChange={() => {}} />
                </td>
              )}
              <td className={basicTdClasses}>{startIndex + rowIndex + 1}</td> {/* Lp. value */}
        {Object.entries(row)
          .filter(([key]) => !hiddenFields.includes(key))
          .map(([key, value]) => (
            <td key={key} className={`${basicTdClasses} relative`}>
              {key === 'Nabywca' && Array.isArray(value) ? (
                <div className="flex flex-col mr-10">
                  {value.map((client, index) => (
                    <div key={index}>{index + 1}. {client}</div>
                  ))}
                </div>
              ) : key === 'payment_status' ? (
                <span className={klasaStatusu(value)}>
                  {value}
                </span>
              ) : (
                value?.toLocaleString('pl-PL')
              )}
            </td>
          ))}
              {hasActions && (
                <>
                <td className={`${basicTdClasses} w-[54px]`}>
                  <Button className="w-[30px] h-[30px] pt-0 pb-0 pr-0 pl-0" variant="flat" onClick={() => handleNavigate(row.flatId, row.clientIds, row.investmentId)} title="Płatności">
                    <img src={PaymentsIcon} alt="Płatności" />
                  </Button>
                </td>
                <td className={`${basicTdClasses} w-[54px]`}>
                  <Button className="w-[30px] h-[30px] pt-0 pb-0 pr-0 pl-0" variant="flat" onClick={() => handleMarkAsUnsoldClick(row.flatId, row.investmentId, row.code)} title="Oznacz jako niesprzedany">
                    <img src={CloseIcon} alt="Niesprzedany" className="w-4 h-4" />
                  </Button>
                </td>
                </>
              )}
            </tr>
          ))}
                  {/* Summary Row */}
        <tr className="bg-[#E6E6E7] border-t font-semibold">
          {editable && <td className="py-[15px] px-[15px] w-[54px]"></td>}
          <td className="py-[15px] px-[15px]">&nbsp;</td>
          {Object.keys(tableData[0] || {}).filter((key) => !hiddenFields.includes(key)).map((key) => (
            <td key={key} className="py-[15px] px-[15px]">{summary[columnHeaders[key]] || '-'}</td>
          ))}
          {hasActions && <td className="py-[15px] px-[15px] w-[54px]"></td>}
          {hasActions && <td className="py-[15px] px-[15px] w-[54px]"></td>}
        </tr>
        </tbody>
      </table>

      {/* Pagination */}
      {filteredData.length > 0 && (
        <Pagination
          currentPage={currentPage}
          totalItems={filteredData.length}
          itemsPerPage={itemsPerPage}
          onPageChange={setCurrentPage}
          onItemsPerPageChange={handleItemsPerPageChange}
        />
      )}

      <ConfirmDialog
        isOpen={flatToUnsold !== null}
        onConfirm={confirmMarkAsUnsold}
        onCancel={() => setFlatToUnsold(null)}
        title="Oznacz jako niesprzedany"
        message={`Czy na pewno chcesz oznaczyć lokal ${flatToUnsold?.flatCode || ''} jako dostępny (niesprzedany)? Status zostanie zmieniony na "available".`}
        confirmText="Tak, oznacz"
        cancelText="Anuluj"
        variant="warning"
      />
    </div>
  );
};

export default TableCustomers;
